import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { productCategories, products } from '@/data/products';

const AICatalogue = () => {
  const groupedProducts = productCategories.map((category) => ({
    ...category,
    products: products.filter((product) => product.category === category.id),
  }));

  return (
    <main className="min-h-screen bg-[#050505] px-4 pb-20 pt-28 text-white">
      <Helmet>
        <title>PhantomPathVPN Product Catalogue</title>
        <meta name="description" content="Current PhantomPathVPN passes, travel eSIM packs, privacy packs, unlimited packs and UK or USA virtual numbers." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <div className="mx-auto max-w-5xl">
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#00ffc8]">Current services</p>
        <h1 className="mt-3 text-3xl font-extrabold sm:text-5xl">PhantomPathVPN Product Catalogue</h1>
        <p className="mt-4 max-w-3xl leading-7 text-gray-300">
          One-off VPN access, travel eSIM data and temporary UK or USA virtual numbers. Prices are displayed in GBP and the available package details below come directly from the current product catalogue.
        </p>

        <div className="mt-10 space-y-10">
          {groupedProducts.map((category) => (
            <section key={category.id} aria-labelledby={`catalogue-${category.id}`}>
              <h2 id={`catalogue-${category.id}`} className="text-2xl font-bold" style={{ color: category.accent }}>{category.label}</h2>
              <p className="mt-1 text-sm text-gray-400">{category.description}</p>
              <div className="mt-4 grid gap-3 sm:grid-cols-2">
                {category.products.map((product) => (
                  <Link key={product.slug} to={`/services/${product.slug}`} className="rounded-xl border border-white/10 bg-white/[0.035] p-4 transition hover:border-white/25">
                    <h3 className="font-bold">{product.name}</h3>
                    <p className="mt-2 text-sm leading-6 text-gray-400">{product.description}</p>
                    <p className="mt-3 font-bold" style={{ color: product.accent }}>{product.price}</p>
                  </Link>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
};

export default AICatalogue;
